import React from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';

import SidebarItem from './components/SidebarItem';
import SidebarHeader from './components/SidebarHeader';

const SimpleSidebar = ({ activeIndex, title, pageTitles, handleViewChange }) => {
  return (
    <React.Fragment>
      <SidebarHeader>{title}</SidebarHeader>
      { map(pageTitles, (pageTitle, i) => {
        return (
          <SidebarItem
            key={pageTitle}
            index={i}
            activeIndex={activeIndex}
            onClick={() => handleViewChange(i)}
          >
            {pageTitle}
          </SidebarItem>
        );
      })}
    </React.Fragment>
  );
};

SimpleSidebar.propTypes = {
  activeIndex: PropTypes.number,
  title: PropTypes.string,
  pageTitles: PropTypes.array,
  handleViewChange: PropTypes.func
};

export default SimpleSidebar;
